import { createContext } from 'react';

export const CarouselContext = createContext<{
  atStart: boolean;
  atEnd: boolean;
  trackRef: React.RefObject<HTMLUListElement | null>;
}>({
  atStart: true,
  atEnd: false,
  trackRef: { current: null },
});
export const CarouselDispatchContext = createContext<{
  setAtStart: React.Dispatch<React.SetStateAction<boolean>>;
  setAtEnd: React.Dispatch<React.SetStateAction<boolean>>;
}>({ setAtStart: () => {}, setAtEnd: () => {} });
